module.exports = __webpack_public_path__ + "img/form_background_mobile.3923702.webp";